import React from 'react';
import { formatFieldDisplayValue } from './splitViewFieldDisplay';

function DetailRow({ label, rawValue }) {
  const text = formatFieldDisplayValue(rawValue);
  if (!text) return null;
  return (
    <div>
      <span className="font-medium text-gray-700 dark:text-gray-300">{label}</span>{' '}
      <span className="text-gray-600 dark:text-gray-400">{text}</span>
    </div>
  );
}

/**
 * Entity context block shown above approval request forms (complaints, documents, etc.).
 */
export default function ApprovalEntitySummary({ entityData }) {
  if (!entityData) return null;

  const title =
    entityData.title ||
    entityData.documentTitle ||
    entityData.ncrTitle ||
    entityData.changeRequestTitle ||
    entityData.complaintTitle;
  const code =
    entityData.code ||
    entityData.documentCode ||
    entityData.ncrCode ||
    entityData.changeRequestCode ||
    entityData.complaintCode;
  const typeValue =
    entityData.priority ||
    entityData.nonConformityType ||
    entityData.changeType ||
    entityData.changeCategory ||
    entityData.complaintType;
  const typeLabel = entityData.priority
    ? 'Priority:'
    : entityData.nonConformityType
      ? 'Type:'
      : entityData.changeType
        ? 'Change Type:'
        : entityData.changeCategory
          ? 'Category:'
          : entityData.complaintType
            ? 'Complaint Type:'
            : 'Type:';
  const byValue =
    entityData.detectedBy || entityData.requestedBy || entityData.reportedBy;
  const byLabel = entityData.detectedBy
    ? 'Detected By:'
    : entityData.requestedBy
      ? 'Requested By:'
      : entityData.reportedBy
        ? 'Reported By:'
        : 'By:';
  const dateRaw =
    entityData.requestedDate || entityData.reportedAt || entityData.createdAt;
  const dateLabel = entityData.requestedDate
    ? 'Requested:'
    : entityData.reportedAt
      ? 'Reported:'
      : 'Created:';

  const hasContent =
    title ||
    code ||
    entityData.version ||
    entityData.revisionNumber ||
    entityData.status ||
    entityData.department ||
    typeValue ||
    entityData.severity ||
    byValue ||
    dateRaw;

  if (!hasContent) return null;

  return (
    <div className="mb-4 rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-gray-700 dark:bg-gray-800/60">
      <div className="space-y-1 text-xs">
        <DetailRow label="Title:" rawValue={title} />
        <DetailRow label="Code:" rawValue={code} />
        <DetailRow label="Version:" rawValue={entityData.version ?? entityData.revisionNumber} />
        <DetailRow label="Status:" rawValue={entityData.status} />
        <DetailRow label="Department:" rawValue={entityData.department} />
        {typeValue ? <DetailRow label={typeLabel} rawValue={typeValue} /> : null}
        <DetailRow label="Severity:" rawValue={entityData.severity} />
        {byValue ? <DetailRow label={byLabel} rawValue={byValue} /> : null}
        {dateRaw ? (
          <div>
            <span className="font-medium text-gray-700 dark:text-gray-300">{dateLabel}</span>{' '}
            <span className="text-gray-600 dark:text-gray-400">
              {new Date(dateRaw).toLocaleDateString()}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
